/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimInformationDataModel} from '../../models/claim-information-data.model';
import {WarningsEnum} from '../../../shared/warnings/warnings.enum';
import {FileSummaryModel} from '../../../api/ms-filemanager/contracts/file-summary.model';

@Component({
    selector: 'app-claim-information-display',
    templateUrl: './claim-information-display.component.html',
    styleUrls: ['./claim-information-display.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimInformationDisplayComponent implements OnInit {

    @Input() claimInformation: ClaimInformationDataModel;
    @Input() attachments: FileSummaryModel[];
    @Input() directory: string;
    @Input() requiredAttachments: boolean;
    @Input() fileManagerOffline: boolean;

    public requiredForSendLabel = 'Required for send';
    WarningEnum = WarningsEnum;

    constructor() {
    }

    @Input() refreshAttachments: Function = () => {
    };

    ngOnInit(): void {
    }

}
